export const LOCAL_STORAGE_ID = '000000000000000000000000';
export const LOCAL_STORAGE_LABEL = 'My Computer';
